import { IPlayoffRoundGroup } from '../../../../../types';
import { isKnouckoutGameDoubles } from '@sportal365/smp-widget-utils/src/isKnouckoutGameDoubles';
import { KnockoutGame as PlayoffKnockoutGame } from './../../PlayoffKnockout/components/KnockoutGame';
import { KnockoutGameDoubles as PlayoffKnockoutGameDoubles } from './../../PlayoffKnockout/components/KnockoutGameDoubles';

export const renderKnockoutGameType = (
  group: IPlayoffRoundGroup,
  handleEventClick?: (id: string | number) => void,
  sport?: string,
  type?: string,
  isNational?: boolean,
  groupName?: string,
  handleOpenMenu?: (value: boolean) => void,
  isMobile?: boolean,
  parentRefHeight?: number,
  handleEnableScroll?: (value: boolean) => void,
): JSX.Element => {
  if (isKnouckoutGameDoubles(type)) {
    return <PlayoffKnockoutGameDoubles isNational={isNational} handleEventClick={handleEventClick} group={group} sport={sport} />;
  }

  return (
    <PlayoffKnockoutGame
      isNational={isNational}
      handleEventClick={handleEventClick}
      group={group}
      sport={sport}
      groupName={groupName}
      isMobile={isMobile}
      handleOpenMenu={handleOpenMenu}
      parentRefHeight={parentRefHeight}
      handleEnableScroll={handleEnableScroll}
    />
  );
};
